import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Invitation } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { driverKeys } from '../../drivers/api';
import { vehicleKeys } from '../../vehicles/api';
import { createUserInvitationApi, invitationKeys, userKeys } from '../api';
import type { InviteUserParams } from '../api';

export function useCreateInvitation(): UseMutationResult<Invitation, Error, InviteUserParams> {
  const client = useApiClient('admin-auth');
  const queryClient = useQueryClient();
  const api = createUserInvitationApi(client);

  return useMutation<Invitation, Error, InviteUserParams>({
    mutationFn: (params: InviteUserParams) => api.inviteUser(params),
    ...createMutationCallbacks({
      invalidateKeys: [invitationKeys.list(), userKeys.all, driverKeys.all, vehicleKeys.all],
      queryClient,
    }),
  });
}
